import * as React from 'react';
import { ISvgAtomProps } from './Atoms.interfaces';

const ProductWeightBased: React.FC<ISvgAtomProps> = ({ width = 190, height = 12 }) => {
  return (
    <svg x={0} y={0} width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <rect x={0} y={0} width={width} height={height} rx={4} fill="rgba(0,0,0,0.02)" />

      <text x={10} y={height / 2} textAnchor="start" dominantBaseline="middle" fill="#7a7a7a" fontSize={8}>
        Price Disclaimer
      </text>
    </svg>
  );
};

export default ProductWeightBased;
